import { useMemo } from "react";
import { RETURN_TEMPLATE_VARIABLES } from "@babackapp/return-variables-registry";
import type { VariableDefinition } from "@babackapp/variables-registry";
import useCurrentShopSuspense from "../hooks/use-current-shop-suspense";

/**
 * Return-domain variable list for the workflows editor dictionary, adapted to
 * the shared `VariableDefinition` shape consumed by the editor core.
 *
 * `ReturnVariableDefinition` is structurally compatible at runtime (same id /
 * name / description / type / group / exampleValue fields); only the literal
 * union types of `group`/`requires`/`availableIn` differ, hence the cast —
 * same pattern as templates-editor/src/lib/return-variables.ts. Memoized so
 * consumers keyed on the array identity (unavailable-variables memo) only
 * recompute when the shop changes.
 */
export function useReturnEditorVariables(): VariableDefinition[] {
  const { data: shop } = useCurrentShopSuspense();

  return useMemo(
    () =>
      RETURN_TEMPLATE_VARIABLES.map((definition) => {
        if (definition.id === "shop.name") {
          return { ...definition, exampleValue: shop.name };
        }
        return definition;
      }) as unknown as VariableDefinition[],
    [shop.name],
  );
}
